import { breakpoints, Checkbox, Inline, RadioGroup, Stack, ValidationMessage, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { NoneOption } from './utils';
import OperatorCard from './OperatorCard';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const errorMessageStyles = css`
  color: ${vars.colors.signal.critical.foreground};
  font-size: 0.875rem;
  min-height: 1.125rem;
`;
const selectionWrapperStyles = css`
  grid-area: 3 / 1 / 4 / 3;
`;
const selectionStyles = css`
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: ${breakpoints._768}) {
    flex-direction: column;
  }
`;
const rejectStyles = css`
  display: flex;
  flex-direction: row;
  grid-area: 4 / 1 / 5 / 3;
  justify-content: end;
`;
const RadioSelection = ({
  input,
  handleChange,
  meta,
  options,
  name,
  translation,
  handleOpenDrawer
}) => {
  const {
    value,
    onChange
  } = input;
  const hasError = Boolean(meta.touched && meta.error) || Boolean(meta.touched && input.value === undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      className: selectionWrapperStyles,
      spacing: 0,
      children: [hasError && meta.error && /*#__PURE__*/_jsx(ValidationMessage, {
        className: errorMessageStyles,
        "data-testid": "airport-transfer-validation",
        role: "alert",
        variant: "error",
        children: meta.error
      }), /*#__PURE__*/_jsx(RadioGroup, {
        className: selectionStyles,
        hasError: hasError,
        name: name,
        onChange: e => {
          handleChange(e);
          onChange(e);
        },
        selectedValue: value,
        children: options.map((option, index) => /*#__PURE__*/_jsx(OperatorCard, {
          handleOpenDrawer: handleOpenDrawer,
          operator: option,
          translation: translation
        }, index))
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      className: rejectStyles,
      noWrap: true,
      children: [/*#__PURE__*/_jsx(Checkbox.Label, {
        htmlFor: "airport-transfer-choice-empty",
        children: translation.reject
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: input.value === NoneOption,
        "data-testid": "airport-transfer-choice-empty",
        hasError: hasError,
        id: "airport-transfer-choice-empty",
        onChange: handleChange,
        value: NoneOption
      })]
    })]
  });
};
export default RadioSelection;
//# sourceMappingURL=RadioSelection.js.map